import {
    IonAvatar,
    IonButton,
    IonContent,
    IonIcon,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonList,
    IonMenu,
    IonMenuToggle,
    IonProgressBar,
    useIonRouter,
} from "@ionic/react";

import { useLocation } from "react-router-dom";
import {
    appsOutline,
    cafeOutline,
    colorFilterOutline,
    earthOutline,
    fastFoodOutline,
    homeOutline,
    logOutOutline,
    mailOutline,
    optionsOutline,
    paperPlaneOutline,
    pencilOutline,
    pricetagOutline,
    restaurantOutline,
} from "ionicons/icons";
import "./Menu.scss";
import { useDispatch, useSelector } from "react-redux";
import { destroyUser, selectAuth, selectUser } from "../store/authSlice";
import { logout } from "../firebase";
import { Paths } from "./routes";
import { ShepherdTour, ShepherdTourContext } from "react-shepherd";
import { useContext } from "react";
import "shepherd.js/dist/css/shepherd.css";

const nextButton = {
    classes: "shepherd-button-primary",
    text: "Next",
    type: "next",
};

const backButton = {
    classes: "shepherd-button-primary",
    text: "Back",
    type: "back",
};

const stepCommonOptions = {
    classes: "",
    highlightClass: "highlight",
    scrollTo: true,
    cancelIcon: {
        enabled: true,
    },
};

const steps: any[] = [
    {
        attachTo: { element: ".menus", on: "bottom" },
        buttons: [nextButton],
        title: "1",
        text: ["React-Shepherd is a JavaScript library for guiding users through your React app."],
        ...stepCommonOptions,
    },
    {
        attachTo: { element: ".recipes-inreview", on: "bottom" },
        buttons: [backButton, nextButton],
        title: "2",
        text: ["React-Shepherd is a JavaScript library for guiding users through your React app."],
        ...stepCommonOptions,
    },
    {
        attachTo: { element: ".published-recipes", on: "bottom" },
        buttons: [backButton],
        title: "3",
        text: ["React-Shepherd is a JavaScript library for guiding users through your React app."],
        ...stepCommonOptions,
    },
];

const tourOptions = {
    defaultStepOptions: {
        cancelIcon: {
            enabled: true,
        },
    },
    useModalOverlay: true,
};

function Button() {
    const tour = useContext(ShepherdTourContext) as any;

    return (
        <button
            className="button dark"
            onClick={tour.start}
        >
            Start Tour
        </button>
    );
}
interface AppPage {
    type: "page";
    url: string;
    icon: string;
    title: string;
    roles?: string[];
}

const appPages: (AppPage | { type: "divider" })[] = [
    {
        type: "page",
        title: "Strona główna",
        url: Paths.startPage,
        icon: homeOutline,
        roles: ["user", "moderator", "admin"],
    },
    {
        type: "page",
        title: "Przepisy",
        url: "/recipes",
        icon: restaurantOutline,
        roles: ["user", "moderator", "admin"],
    },
    {
        type: "page",
        title: "Jadłospisy - prywatne",
        url: "/user/menus",
        icon: fastFoodOutline,
        roles: ["user", "moderator", "admin"],
    },
    {
        type: "page",
        title: "Jadłospisy - publiczne",
        url: "/menus",
        icon: earthOutline,
    },
    { type: "divider" },
    {
        type: "page",
        title: "Jednostki",
        url: "/dictionaries/units",
        icon: optionsOutline,
        roles: ["moderator", "admin"],
    },
    {
        type: "page",
        title: "Kategorie przepisów",
        url: "/dictionaries/recipeCategories",
        icon: appsOutline,
        roles: ["moderator", "admin"],
    },
    {
        type: "page",
        title: "Kategorie składników",
        url: "/dictionaries/ingredientCategories",
        icon: appsOutline,
        roles: ["moderator", "admin"],
    },
    {
        type: "page",
        title: "Składniki",
        url: "/dictionaries/ingredients",
        icon: colorFilterOutline,
        roles: ["moderator", "admin"],
    },
    {
        type: "page",
        title: "Tagi",
        url: "/dictionaries/tags",
        icon: pricetagOutline,
        roles: ["moderator", "admin"],
    },
];

const publicAppPages: (AppPage | { type: "divider" })[] = [
    {
        type: "page",
        title: "Jadłospisy - publiczne",
        url: "/menus",
        icon: earthOutline,
    },
    {
        type: "page",
        title: "Zarejestruj",
        url: "/register",
        icon: mailOutline,
    },
    {
        type: "page",
        title: "Zaloguj",
        url: "/login",
        icon: paperPlaneOutline,
    },
];

export const NavigationMenu: React.FC = () => {
    const location = useLocation();
    const user = useSelector(selectAuth).user;
    const dispatch = useDispatch();
    const router = useIonRouter();
    let pages = publicAppPages;
    if (user.role !== "anonymous")
        pages = appPages.filter((p) => p.type === "divider" || p.roles === undefined || p.roles.includes(user.role));

    return (
        <IonMenu
            contentId="main"
            type="overlay"
        >
            <IonContent>
                <div className="main-section">
                    {pages.map((appPage, index) => {
                        if (appPage.type === "divider") {
                            return (
                                <IonMenuToggle
                                    key={index}
                                    autoHide={false}
                                >
                                    <IonItemDivider />
                                </IonMenuToggle>
                            );
                        }
                        return (
                            <IonMenuToggle
                                key={index}
                                autoHide={false}
                            >
                                <IonItem
                                    className={location.pathname === appPage.url ? "selected" : ""}
                                    routerLink={appPage.url}
                                    routerDirection="none"
                                    lines="none"
                                    detail={false}
                                >
                                    <IonIcon
                                        slot="start"
                                        ios={appPage.icon}
                                        md={appPage.icon}
                                    />
                                    <IonLabel>{appPage.title}</IonLabel>
                                </IonItem>
                            </IonMenuToggle>
                        );
                    })}
                </div>
                {user.role === "anonymous" && (
                    <div className="profile-section">
                        <IonList>
                            <IonItem
                                href="https://buycoffee.to/feedme"
                                routerDirection="none"
                                lines="none"
                                detail={false}
                            >
                                <IonIcon
                                    slot="start"
                                    icon={cafeOutline}
                                />
                                <IonLabel>Wesprzyj nas!</IonLabel>
                            </IonItem>
                        </IonList>
                    </div>
                )}
                {user.role !== "anonymous" && (
                    <div className="profile-section">
                        <IonList>
                            <IonItem
                                href="https://buycoffee.to/feedme"
                                routerDirection="none"
                                lines="none"
                                detail={false}
                            >
                                <IonIcon
                                    slot="start"
                                    icon={cafeOutline}
                                />
                                <IonLabel>Wesprzyj nas!</IonLabel>
                            </IonItem>
                            <IonItem
                                className={location.pathname === Paths.feedback ? "selected" : ""}
                                routerLink={Paths.feedback}
                                routerDirection="none"
                                lines="none"
                                detail={false}
                            >
                                <IonIcon
                                    slot="start"
                                    icon={pencilOutline}
                                />
                                <IonLabel>Napisz do nas!</IonLabel>
                            </IonItem>
                        </IonList>
                        <div className="avatar-section">
                            <IonAvatar>
                                <img
                                    alt="Silhouette of a person's head"
                                    src="https://ionicframework.com/docs/img/demos/avatar.svg"
                                />
                            </IonAvatar>
                            <IonLabel>{user.name}</IonLabel>
                            <div className="separator" />
                            <IonButton
                                expand="full"
                                fill="clear"
                                onClick={async () => {
                                    await logout();
                                    dispatch(destroyUser());
                                    router.push(Paths.login, "root");
                                }}
                            >
                                <IonIcon icon={logOutOutline} />
                            </IonButton>
                        </div>
                    </div>
                )}
            </IonContent>
        </IonMenu>
    );
};
